
import React from 'react';
import SharedDefaultLayout from 'shared-resources/components/src/DefaultLayout';
import { useLoggedInUser } from '../../../resources/user/authService';
import { useGetGroupList } from '../../../resources/group/groupService';
import { myGroupsEndpoint } from '../../../resources/group/groupStore';
import SelectOrganizationInput from '../../../resources/organization/components/SelectOrganizationInput';
import { useParams, Redirect } from 'react-router-dom'

const DefaultLayout = (props) => {
  // Layout needs loggedInUser to be passed in
  const loggedInUser = useLoggedInUser();
  const { organizationId } = useParams();
  const { data: groups, otherData, ...groupQuery } = useGetGroupList(myGroupsEndpoint);

  const organizations = otherData?.organizations || [];
  const groupUsers = otherData?.groupUsers || [];

  const navigateToOrganization = (e) => {
    const selectedOrganizationId = e.target.value;
    window.location.href = `/${selectedOrganizationId}`
  };

  return (
    <SharedDefaultLayout
      {...props}
      headerComponent={() => (
        <SelectOrganizationInput
          organizations={organizations}
          change={navigateToOrganization}
          selectedOrganizationId={organizationId || ''}
        />
      )}
      loggedInUser={loggedInUser}
      groups={groups}
      organizations={organizations}
      groupUsers={groupUsers}
      organizationId={organizationId}
    />
  );
};

DefaultLayout.propTypes = SharedDefaultLayout.propTypes;
DefaultLayout.Skeleton = SharedDefaultLayout.Skeleton;

// wrap the above so we check for logged in user and redirect to login if not logged in
// this avoids infinite redirect loops that can happen if we attempt group fetch with no logged in user
export const LoggedInUserGate = (props) => {
  const loggedInUser = useLoggedInUser();
  if (!loggedInUser) {
    // preserve current route as redirect after login, even if it's a nonsense route, at least they'll finally end at NotFound
    const currentPath = window.location.pathname + window.location.search;
    return <Redirect to={`/user/login?redirect=${encodeURIComponent(currentPath)}`} />;
  }

  return <DefaultLayout {...props} />;
};

LoggedInUserGate.propTypes = SharedDefaultLayout.propTypes;
LoggedInUserGate.Skeleton = SharedDefaultLayout.Skeleton;
export default LoggedInUserGate;
